<template>
  <div class="small-rounded-btn toggle-up">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.828"
      height="11.828"
      viewBox="0 0 20.828 11.828"
    >
      <g
        id="Gruppe_281"
        data-name="Gruppe 281"
        transform="translate(1.414 1.414)"
      >
        <line
          id="Linie_36"
          data-name="Linie 36"
          y1="9"
          x2="9"
          fill="none"
          stroke="rgba(221,112,3,0.87)"
          stroke-linecap="round"
          stroke-width="2"
        />
        <line
          id="Linie_37"
          data-name="Linie 37"
          x1="9"
          y1="9"
          transform="translate(9)"
          fill="none"
          stroke="rgba(221,112,3,0.87)"
          stroke-linecap="round"
          stroke-width="2"
        />
      </g>
    </svg>
  </div>
</template>
